import styles from '../Settings.module.css';

export interface TimeInputProps {
  value: string; // HH:MM format
  onChange: (value: string) => void;
  label: string;
}

export function TimeInput({ value, onChange, label }: TimeInputProps) {
  // Parse HH:MM format
  const [hourStr, minuteStr] = value.split(':');
  const hour24 = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  // Convert to 12-hour format
  const isPM = hour24 >= 12;
  const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;

  const handleHourChange = (newHour12: number) => {
    let newHour24 = newHour12;
    if (isPM && newHour12 !== 12) {
      newHour24 = newHour12 + 12;
    } else if (!isPM && newHour12 === 12) {
      newHour24 = 0;
    }
    onChange(`${newHour24.toString().padStart(2, '0')}:${minuteStr}`);
  };

  const handleMinuteChange = (newMinute: number) => {
    onChange(`${hourStr}:${newMinute.toString().padStart(2, '0')}`);
  };

  const handleAmPmChange = (newIsPM: boolean) => {
    let newHour24: number;
    if (newIsPM) {
      newHour24 = hour12 === 12 ? 12 : hour12 + 12;
    } else {
      newHour24 = hour12 === 12 ? 0 : hour12;
    }
    onChange(`${newHour24.toString().padStart(2, '0')}:${minuteStr}`);
  };

  return (
    <div className={styles.timeInput} aria-label={label}>
      <select
        className={styles.timeSelect}
        value={hour12}
        onChange={(e) => handleHourChange(parseInt(e.target.value, 10))}
        aria-label="Hour"
      >
        {[12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((h) => (
          <option key={h} value={h}>
            {h.toString().padStart(2, '0')}
          </option>
        ))}
      </select>
      <span className={styles.timeSeparator}>:</span>
      <select
        className={styles.timeSelect}
        value={minute}
        onChange={(e) => handleMinuteChange(parseInt(e.target.value, 10))}
        aria-label="Minute"
      >
        {[0, 15, 30, 45].map((m) => (
          <option key={m} value={m}>
            {m.toString().padStart(2, '0')}
          </option>
        ))}
      </select>
      <select
        className={styles.amPmSelect}
        value={isPM ? 'PM' : 'AM'}
        onChange={(e) => handleAmPmChange(e.target.value === 'PM')}
        aria-label="AM or PM"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}
